import { render } from "./MapyCzOrtophotoLayer.vue?vue&type=template&id=71efb6f2&ts=true"
import script from "./MapyCzOrtophotoLayer.vue?vue&type=script&lang=ts"
export * from "./MapyCzOrtophotoLayer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__